{
  "close": "Luk",
  "notifications": "Påmindelser"
}
